import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UnderMaintenanceService } from '..';

@Component({
    selector: 'jow-under-maintenance',
    templateUrl: './under-maintenance.component.html',
    styleUrls: ['./under-maintenance.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class UnderMaintenanceComponent implements OnInit {

  from: Date;
  until: Date;

  constructor(private underMaintenanceService: UnderMaintenanceService) { }

  ngOnInit(): void {
    this.from = this.underMaintenanceService.from;
    this.until = this.underMaintenanceService.until;
  }

}
